"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// tslint:disable-next-line: variable-name
exports.FormContext = React.createContext({});
// tslint:disable-next-line: variable-name
exports.ParentNameContext = React.createContext('');
// tslint:disable-next-line: variable-name
function withForm(Component) {
    return /** @class */ (function (_super) {
        __extends(ComponentWithFormContext, _super);
        function ComponentWithFormContext() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ComponentWithFormContext.prototype.render = function () {
            var _this = this;
            return (React.createElement(exports.FormContext.Consumer, null, function (form) { return React.createElement(Component, __assign({}, _this.props, { form: form })); }));
        };
        return ComponentWithFormContext;
    }(React.Component));
}
exports.withForm = withForm;
// tslint:disable-next-line: variable-name
function withParentName(Component) {
    // tslint:disable-next-line:max-classes-per-file
    return /** @class */ (function (_super) {
        __extends(ComponentWithParentNameContext, _super);
        function ComponentWithParentNameContext() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ComponentWithParentNameContext.prototype.render = function () {
            var _this = this;
            return (React.createElement(exports.ParentNameContext.Consumer, null, function (parentName) { return React.createElement(Component, __assign({}, _this.props, { parentName: parentName })); }));
        };
        return ComponentWithParentNameContext;
    }(React.Component));
}
exports.withParentName = withParentName;
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/context.js
// module id = 9
// module chunks = 0